import { Button, Group, Title, Tooltip } from "@mantine/core";
import type { ExpressionOperator } from "../ExpressionEditor";

interface VariablesAndOperatorsSectionProps {
  variables: Array<string>;
  operators: Array<ExpressionOperator>;
  otherElements: Array<ExpressionOperator>;
  insertVariable: (variable: string) => void;
  insertText: (text: string) => void;
}

function VariablesAndOperatorsSection({
  variables,
  operators,
  otherElements,
  insertVariable,
  insertText
}: VariablesAndOperatorsSectionProps) {
  return (
    <>
      <Title order={5} size="sm">
        Variablen
      </Title>
      <Group gap="sm">
        {variables.map((variable, i) => (
          <Button
            key={i}
            variant="default"
            onClick={() => insertVariable(variable)}
          >
            {variable}
          </Button>
        ))}
      </Group>
      <Title order={5} size="sm">
        Operatoren
      </Title>
      <Group gap="sm">
        {operators.map((operator, i) => (
          <ExpressionOperatorButton
            key={i}
            operator={operator}
            onClick={() => insertText(operator.value)}
          />
        ))}
      </Group>
      <Title order={5} size="sm">
        Andere
      </Title>
      <Group gap="sm">
        {otherElements.map((otherElement, i) => (
          <ExpressionOperatorButton
            key={i}
            operator={otherElement}
            onClick={() => insertText(otherElement.value)}
          />
        ))}
      </Group>
    </>
  );
}

function ExpressionOperatorButton({
  operator,
  onClick
}: {
  operator: ExpressionOperator;
  onClick: () => void;
}) {
  if (!operator.description)
    return (
      <Button variant="default" onClick={onClick}>
        {operator.value.replace(/\(.*\)/, "")}
      </Button>
    );
  return (
    <Tooltip label={operator.description}>
      <Button variant="default" onClick={onClick}>
        {operator.value.replace(/\(.*\)/, "")}
      </Button>
    </Tooltip>
  );
}

export { VariablesAndOperatorsSection };
